import { useSessionContext } from '../security/context/SessionContext';
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import Navbar from '../components/navigation/Navbar';
import Footer from '../components/Footer';
import React from 'react';

const HIDE_NAVBAR_PATHS = [
  "/sec/log-in",
  "/sec/create-account",
  "/sec/verify/:token",
  "/sec/verify"
];

const SecurityLayout = () => {
    const { session } = useSessionContext();
    const location = useLocation();

    const hideNavbar = HIDE_NAVBAR_PATHS.some(path =>
        location.pathname.startsWith(path)
    );

    if (session.isAuthenticated) {
        return <Navigate to="/" />;
    }


    return (
        <React.Fragment>
            {!hideNavbar && <Navbar />}
            <div className="content">
                <Outlet />
            </div>
            <Footer />
        </React.Fragment>
    );
}

export default SecurityLayout;


// import { useSessionContext } from '../security/context/SessionContext';
// import { Navigate, Outlet } from 'react-router-dom'

// const SecurityLayout = () => {
//     const { session } = useSessionContext();
//     return !session.isAuthenticated ? <Outlet /> : <Navigate to="/" />;
    
// }

// export default SecurityLayout